import { render } from "./Chatter.vue?vue&type=template&id=6f442055"
import script from "./Chatter.vue?vue&type=script&lang=js"
export * from "./Chatter.vue?vue&type=script&lang=js"
script.render = render

export default script